type PaymentOrderStatusDetails = {
  status: string;
};

interface PaymentOrderActiveDetails {
  orderId: number;
  orderType: PaymentOrderType;
  receiverId: number;
  receiverName: string;
  receiverPicture?: string;
  receiverOnboarded: boolean;
  payerId: number;
  payerName: string;
  payerPicture?: string;
  payerType: PayerType;
  amount: number;
  description: string;
  status: PaymentOrderStatus;
  isReceiverEntity: boolean;
  paymentRequestType: PaymentRequestType;
}

enum PaymentOrderDetailsState {
  ACTIVE = 'ACTIVE',
  FINALIZED = 'FINALIZED',
}

export enum PaymentRequestType {
  ONLY_MARKABLE = 'ONLY_MARKABLE',
  OPP = 'OPP',
  SC_LINK = 'SC_LINK',
  SC_CHECKOUT_INTENT = 'SC_CHECKOUT_INTENT',
  SC_SINGLE_DIRECT_DEBIT = 'SC_SINGLE_DIRECT_DEBIT',
  SC_DIRECT_DEBIT = 'SC_DIRECT_DEBIT',
}

type PaymentOrderDetailsDto = PaymentOrderActiveDetails & {
  state: PaymentOrderDetailsState;
};

type OneTimePayerDetails = {
  name: string;
  email: string;
};

type PayRequestDto = {
  orderId: number;
  payerType: PayerType;
  payerOneTimePayer?: OneTimePayerDetails;
  paymentMethod?: 'card' | 'ideal' | 'any';
};
enum PaymentOrderType {
  BALANCE_SETTLING = 'BALANCE_SETTLING',
  EXPENSE_PAYMENT = 'EXPENSE_PAYMENT',
  P2P = 'P2P',
  JOINT_ACCOUNT_FUNDING = 'JOINT_ACCOUNT_FUNDING',
  P2B = 'P2B',
}

enum PayerType {
  USER = 'USER',
  NATIVE_CONTACT = 'NATIVE_CONTACT',
  LOCAL_CONTACT = 'LOCAL_CONTACT',
  ONE_TIME_PAYER = 'ONE_TIME_PAYER',
}

enum PaymentOrderStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
  TO_BE_REFUNDED = 'TO_BE_REFUNDED',
  AUTHORIZED = 'AUTHORIZED',
}

export type {
  OneTimePayerDetails,
  PayRequestDto,
  PaymentOrderDetailsDto,
  PaymentOrderActiveDetails,
  PaymentOrderStatusDetails,
};

export interface PaymentUserDetailsDto {
  id: number;
  alias: string;
  picture?: string;
  disabled?: boolean;
}

export { PaymentOrderDetailsState, PaymentOrderType, PayerType, PaymentOrderStatus };
